import { useContext, useEffect, useRef } from "react";
import { LayoutContext } from "../layout-context-container";
import './_interstitial.scss';
import PatientModal from "../modal";
import Button from "../button";

function PatientInterstitial({showCloseButton = false}) {
  const modalRef = useRef(null);
  const {setShowMobileMenu, modalState, setModalState, modalButtonUrl, modalTargetBlank} = useContext(LayoutContext);

  useEffect(() => {
    if (modalState) {
      modalRef.current?.open();
      setTimeout(() => {
        const button = document.getElementById('patient-interstitial__buttons__leave');
        button.focus();

      }, 333);
    } else {
      modalRef.current?.close();
    }
  }, [modalState])
  return (
    <PatientModal
      ref={modalRef}
      showCloseButton={showCloseButton}
      customClass={"patient-interstitial__modal"}
    >
      <h3 className='patient-interstitial__header'>YOU'RE NOW LEAVING THE WHAT THE C@H?! WEBSITE</h3>
      <div className='patient-interstitial__buttons'>
        <Button
          id="patient-interstitial__buttons__leave"
          variant="large-text"
          type=""
          buttonUrl={modalButtonUrl}
          targetBlank={modalTargetBlank}
          onClick={() => {
            setShowMobileMenu(false);
            setModalState(false);
          }}
          data-gtm-event-name="Link Click"
          data-gtm-event-label="Leave site"
          data-gtm-event-action="Click"
          data-gtm-event-category="Navigation"
        >
          Leave Site
        </Button>
        <Button
          variant="transparent"
          type=""
          externalLink={false}
          onClick={() => setModalState(false)}
          data-gtm-event-name="Link Click"
          data-gtm-event-label="Stay on site"
          data-gtm-event-action="Click"
          data-gtm-event-category="Navigation"
        >
          Stay on site
        </Button>

      </div>
    </PatientModal>
  );
}

export default PatientInterstitial;